import type React from 'react'

import type { IDropdownCourseContent } from './DropdownCourse'
import type { IChildrenHandler } from './types'

interface IGetHandlersParams {
  children: IChildrenHandler
  triggerOpen: (nextOpen: boolean) => void
  type: IDropdownCourseContent['type']
}

export const getMergedHandlers = ({ children, type, triggerOpen }: IGetHandlersParams) => {
  return {
    onMouseEnter: (e: React.MouseEvent) => {
      children.props.onMouseEnter?.(e)
      if (type === 'tooltip') {
        triggerOpen(true)
      }
    },
    onClick: (e: React.MouseEvent) => {
      children.props.onClick?.(e)
      if (type === 'dropdown') {
        triggerOpen(true)
      }
    },
    onFocus: (e: React.FocusEvent) => {
      children.props.onFocus?.(e)
      if (type === 'tooltip') {
        triggerOpen(true)
      }
    },
    onBlur: (e: React.FocusEvent) => {
      children.props.onBlur?.(e)
      if (type === 'tooltip') {
        triggerOpen(false)
      }
    },
    onKeyDown: (e: React.KeyboardEvent) => {
      children.props.onKeyDown?.(e)
      switch (e.key) {
        case 'Escape':
          triggerOpen(false)
          break
        case 'Enter':
        case 'ArrowDown':
        case 'ArrowUp':
          if (type === 'tooltip') {
            triggerOpen(false)
          }
          break
        default:
          break
      }
    },
  }
}
